import mixinActions from '../core/actions';
import mixinMutations from '../core/mutations';
import mixinGetters from '../core/getters';
import Vue from 'vue';
import axios from 'axios';

export default {
    namespaced: true,
    state: {
        teams: [],
        repositoryName: 'teams',
        filters: {
            name: '',
            countryId: null,
            typeId: null,
            women: null,
            youth: null,
            // limitsCategoryId: null,
            isFavoriteOnly: false,
        },
        isShowExtraFilters: false,
        favoriteTeam: [],
        favoriteTeamProcessing: {},
    },
    mutations: {
        ...mixinMutations(),

        setFavoriteTeam(state, favoriteTeam) {
            state.favoriteTeam = favoriteTeam;
        },

        setFavoriteTeamProcessing(state, favoriteTeamProcessing) {
            state.favoriteTeamProcessing = favoriteTeamProcessing;
        },
    },
    getters: {
        ...mixinGetters(),

        getFavoriteTeam(state) {
            return state.favoriteTeam;
        },

        getFavoriteTeamProcessing(state) {
            return state.favoriteTeamProcessing;
        },
    },
    actions: {
        ...mixinActions('team'),

        toggleFavoriteTeam(context, data) {
            //we use favoriteTeamProcessing for disable extra click to start icon to avoid wrong request
            if (data.item.ctId in context.state.favoriteTeamProcessing) {
                return false;
            }

            Vue.set(context.state.favoriteTeamProcessing, data.item.ctId, true);

            if (context.state.favoriteTeam[data.item.ctId]) {
                Vue.delete(context.state.favoriteTeam, data.item.ctId);

                axios
                    .post('/api/favoriteTeam/delete', {
                        rows: [{ id: data.item.ctId }],
                    })
                    .then((response) => {
                        Vue.delete(context.state.favoriteTeamProcessing, data.item.ctId);
                    });
            } else {
                Vue.set(context.state.favoriteTeam, data.item.ctId, 1);
                axios
                    .post('/api/favoriteTeam/create', {
                        rows: [{ ctId: data.item.ctId }],
                    })
                    .then((response) => {
                        Vue.delete(context.state.favoriteTeamProcessing, data.item.ctId);
                    });
            }
        },
    },
};
